import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "./App.css";
import Overlay from "./helpers/Overlay.jsx";

import Home from "./components/Home/Home.jsx";
import About from "./components/About/About.jsx";
import Concerts from "./components/Concerts/Concerts.jsx";
import Discography from "./components/Discography/Discography.jsx";
import Photogallery from "./components/Photogallery/Photogallery.jsx";
import Service from "./components/Service/Service.jsx";
import Contacts from "./components/Contacts/Contacts.jsx";

import Header from "./components/UI/Header/Header.jsx";
import Card from "./components/UI/Card/Card.jsx";
import Logo from "./components/UI/Logo/Logo.jsx";
import Navbar from "./components/UI/Navbar/Navbar.jsx";
import Sidebar from "./components/UI/Sidebar/Sidebar.jsx";

class App extends Component {
  state = {
    lang: "cs-CZ",
  };

  changeLang = (lang) => {
    this.setState({ lang: lang });
  };

  render() {
    let { lang } = this.state;
    return (
      <Router>
        <div className="App">
          <Overlay />
          <Header lang={lang} changeLang={this.changeLang} />
          <Card>
            <Logo lang={lang} />
            <Navbar lang={lang} />
          </Card>
          <section className="mainContainer">
            <div className="leftContainer">
              <Route
                path="/"
                exact
                render={(props) => <Home {...props} lang={lang} />}
              />
              <Route
                path="/About"
                exact
                render={(props) => <About {...props} lang={lang} />}
              />
              <Route
                path="/Discography"
                exact
                render={(props) => <Discography {...props} lang={lang} />}
              />
              <Route
                path="/Concerts"
                exact
                render={(props) => <Concerts {...props} lang={lang} />}
              />
              <Route
                path="/Photogallery"
                exact
                render={(props) => <Photogallery {...props} lang={lang} />}
              />
              <Route
                path="/Service"
                exact
                render={(props) => <Service {...props} lang={lang} />}
              />
              <Route
                path="/Contacts"
                exact
                render={(props) => <Contacts {...props} lang={lang} />}
              />
            </div>
            <Sidebar lang={lang} />
          </section>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js